import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { ApiCrudService } from './api-crud.service';
import { map } from 'rxjs/operators';

export interface UploadedFile {
  id: number;
  name: string;
  type: string;
  url: string;
  creationDate: Date;
}

@Injectable({
  providedIn: 'root'
})
export class FileService extends ApiCrudService<UploadedFile> {

  url = 'files';

  constructor(
    protected http: HttpClient
  ) {
    super();
  }

  upload(data: FormData) {
    return this.http.post(this.url, data, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      map(event => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            const progress = Math.round(100 * event.loaded / event.total);
            return { status: 'progress', message: progress };
          case HttpEventType.Response:
            return { ...{ type: '' }, ...event.body };
          default:
            return 'Unhandled event ' + event.type;
        }
      })
    );
  }

  replaceFile(fileId: number, newFile: File, name?: string) {
    const formData = new FormData();
    formData.append('file', newFile);
    formData.append('name', name || newFile.name);
    formData.append('type', newFile.type)

    return this.http.put(`${this.url}/${fileId}`, formData, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      map(event => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            const progress = Math.round(100 * event.loaded / event.total);
            return { status: 'progress', message: progress };
          case HttpEventType.Response:
            return { ...{ type: '' }, ...event.body };
          default:
            return 'Unhandled event ' + event.type;
        }
      })
    );
  }

  updateName(fileId: number, name: string) {
    return this.http.put(`${this.url}/${fileId}`, { name })
  }

  getFileIcon(type: string): string {
    if (type.includes('image')) {
      return "image";
    } else if (type.includes('video')) {
      return "video";
    } else if (type.includes('presentation') || type.includes('powerpoint')) {
      return "powerpoint";
    } else if (type.includes('word')) {
      return "word";
    } else if (type.includes('pdf')) {
      return "pdf";
    } else if (type.includes('ms-excel') || type.includes('spreadsheetml')) {
      return "excel";
    } else
      return "file";
  }
}
